module.exports = __webpack_public_path__ + "static/media/aquazone.fb874cc2.jpg";